module.exports = __webpack_public_path__ + "img/08-min.88a2033e.jpg";